import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import { routes } from 'utils/routeHelper';
import { scopes } from 'utils/scope';
import AuthorizationComponent from 'components/common/AuthorizationComponent';
import { clearPaginateStorage } from 'utils/paginateStorage';
import './styles.scss';

interface IProps {
  handleLogout: (e: SyntheticEvent<HTMLAnchorElement>) => Promise<void>;
  currentUserRoles: string[];
  currentUserScopes: string[];
}

const MenuItems = (props: IProps) => (
  <ul data-testid="dropdown-menu" styleName="dropdown-menu">
    <AuthorizationComponent requiredScope={scopes.PATIENT_SUMMARY_LIST}>
      <li>
        <Link
          data-testid="dropdown-item"
          styleName="item"
          to={routes.PATIENT_SUMMARY}
          onClick={() => clearPaginateStorage()}
          title="View All Patients"
        >
          View All Patients
        </Link>
      </li>
    </AuthorizationComponent>

    <AuthorizationComponent requiredScope={scopes.LOCATION_READ}>
      <li>
        <Link
          data-testid="dropdown-item"
          onClick={() => clearPaginateStorage()}
          to={routes.MANAGE_LOCATIONS}
          styleName="item"
          title="Manage Locations"
        >
          Manage Locations
        </Link>
      </li>
    </AuthorizationComponent>

    <AuthorizationComponent requiredScope={scopes.MANAGE_PATIENTS_LIST}>
      <li>
        <Link
          data-testid="dropdown-item"
          to={routes.MANAGE_PATIENTS}
          onClick={() => clearPaginateStorage()}
          styleName="item"
          title="Manage Patients"
        >
          Manage Patients
        </Link>
      </li>
    </AuthorizationComponent>

    <AuthorizationComponent requiredScope={scopes.MANAGE_CLINICIANS_LIST}>
      <li>
        <Link
          data-testid="dropdown-item"
          to={routes.MANAGE_CLINICIANS}
          styleName="item"
          onClick={() => clearPaginateStorage()}
          title="Manage Clinicians"
        >
          Manage Clinicians
        </Link>
      </li>
    </AuthorizationComponent>

    <AuthorizationComponent requiredScope={scopes.PATIENT_ADHERENCE_LIST}>
      <li>
        <Link
          data-testid="dropdown-item"
          to={routes.MANAGE_PATIENT_ADHERENCE}
          styleName="item"
          onClick={() => clearPaginateStorage()}
          title="View Patient Adherence"
        >
          View Patient Adherence
        </Link>
      </li>
    </AuthorizationComponent>
    <li>
      <Link
        data-testid="dropdown-item"
        styleName="item"
        to={routes.DOCUMENTS_DASHBOARD}
        title="Documents"
        onClick={() => clearPaginateStorage()}
      >
        Documents
      </Link>
    </li>
    <li>
      <Link
        data-testid="dropdown-item"
        styleName="item"
        title="Log Out"
        onClick={props.handleLogout}
        to={routes.LOG_IN}
      >
        Log Out
      </Link>
    </li>
  </ul>
);

export default MenuItems;
